export default __webpack_public_path__ + "static/media/logo.9cd0984a.jpeg";